<template>
  <div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h4 v-if="showAddressAndSite" >{{ this.$store.state.site.name }}<br>
            <small class="disclaimer-color"> {{this.$store.state.site.address}}</small>
            <hr>
          </h4>
        </div>
        <h4 class="text-center">
          <span v-if="labName">{{ labName + " " }}</span><span class="remove-padding">{{computeCaption(fields_en['consent'], $store.state.lang.value.toLowerCase())}}</span>
        </h4>
        <p :class="allow_scrollbar ? 'disclaimer-color scroll-content' : 'disclaimer-color'" v-html="consent_text">
        </p>
        <hr v-if="allow_checkbox_consent">
        <div class="general-active-section p-2" :class="validatedConsentClass" v-touch:end="checkValidationsConsent" v-on:mouseleave="checkValidationsConsent">
        <p-checkbox v-if="allow_checkbox_consent" v-model="model.agreedConsent" name="agreedConsent" class="required"
                    v-validate="modelValidations.agreedConsent"
        > {{ computeCaption(fields_en['i_agree'], $store.state.lang.value.toLowerCase()) }} </p-checkbox>
        <small class="text-danger" v-show="agreedConsent.invalid" v-if="allow_checkbox_consent">
          {{getError('agreedConsent') && computeCaption(getError('agreedConsent'), $store.state.lang.value.toLowerCase())}}
        </small>
        <hr>
        <div v-if="allow_signature">
          <label class="control-label required">
            {{ computeCaption(fields_en['please_sign'], $store.state.lang.value.toLowerCase()) }}
          </label>
          <VueSignaturePad class="signature" id="signature-consent" width="100%" height="200px" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}" />
          <div class="flex-end">
            <br>
            <el-button plain @click="clear">{{ computeCaption(fields_en['clear'], $store.state.lang.value.toLowerCase()) }}</el-button>
          </div>
          <br>
          <small class="text-danger" v-if="!signature && submit">
            {{ computeCaption(fields_en['please_sign_error'], $store.state.lang.value.toLowerCase()) }}
          </small>
          <br><br>
          <div class="row mt-5">
            <div class="col-md-5">
              <div class="form-group">
                <label class="control-label" :class="allow_text_name ? 'required' : ''" for="text-signature-consent">
                  {{computeCaption(fields_en['if_you_can_not_sign'], $store.state.lang.value.toLowerCase())}}
                </label>
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <el-input type="textarea" name="text-signature-consent" id="text-signature-consent" v-model="signature_text" onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"></el-input>
              </div>
            </div>
          </div>
          <br>
          <small class="text-danger" v-if="text_name_error && submit">
            {{ computeCaption(fields_en['please_enter_name'], $store.state.lang.value.toLowerCase()) }}
          </small>
          <canvas class="disclaimer-consent-canvas" id="disclaimer-consent-canvas"></canvas>
        </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {mapFields} from 'vee-validate'
  import { Button, Input } from 'element-ui'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input
    },
    mixins: [FormatterUtils, TranslationsUtils],
    data () {
      return {
        signature: '',
        signature_text: '',
        submit: false,
        labName: this.$store.state.configs.LAB_NAME,
        showAddressAndSite: this.$store.state.configs.SHOW_ADDRESS_DISCLAIMER,
        allow_signature: this.$store.state.configs.ALLOW_SIGNATURE_CONSENT,
        allow_text_name: this.$store.state.configs.CONSENT_NAME_TEXT_REQUIREMENT,
        allow_checkbox_consent: this.$store.state.configs.ALLOW_CHECKBOX_CONSENT,
        allow_scrollbar: this.$store.state.configs.SCROLLBAR_DISCLAIMER_CONSENT,
        text_name_error: '',
        validationObjectConsent: {
          signatureConsentValidation: false,
          signatureConsentTextValidation: false,
          agreedConsentValidation: false
        },
        validatedConsentClass: '',
        model: {
          agreedConsent: false
        },
        text: '',
        modelValidations: {
          agreedConsent: {
            required: true
          }
        },
        fields_en: {
          if_you_can_not_sign: this.$store.state.configs.CONSENT_NAME_TEXT || 'If you can not sign using the signature panel above, please type your full name as your signature here',
          i_agree: 'I agree',
          consent: 'Consent',
          please_sign: 'Patient or Legal Guardian Signature',
          clear: 'Clear',
          please_sign_error: 'Please Sign!',
          please_enter_name: 'Please enter your name!'
        }
      }
    },
    methods: {
      checkValidationsConsent () {
        if (!this.allow_text_name || !this.allow_signature) {
          this.validationObjectConsent.signatureConsentTextValidation = true
        }
        if (!this.allow_checkbox_consent) {
          this.validationObjectConsent.agreedConsentValidation = true
        }
        if (this.allow_signature) {
          if (!this.$refs.signaturePad.isEmpty() || this.signature_text !== '' && !this.allow_text_name) {
            this.validationObjectConsent.signatureConsentValidation = true
          } else {
            this.validationObjectConsent.signatureConsentValidation = false
          }
        } else {
          this.validationObjectConsent.signatureConsentValidation = true
        }
      },
      clear () {
        this.$refs.signaturePad.clearSignature()
        this.checkValidationsConsent()
      },
      save () {
        const { data } = this.$refs.signaturePad.saveSignature()
        this.signature = data
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        if (this.allow_signature) {
          this.save()
        }
        this.submit = true
        if (this.allow_checkbox_consent && !this.model.agreedConsent) {
          this.$validator.errors.add({field: 'agreedConsent', msg: this.computeCaption('Please accept!', this.$store.state.lang.value.toLowerCase())})
          let field = this.$validator._resolveField('agreedConsent')
          field.setFlags({invalid: true})
          return false
        }
        if (this.allow_text_name && !this.signature_text && this.allow_signature) {
          this.text_name_error = 'error'
          return false
        } else {
          this.text_name_error = ''
        }
        if (this.allow_signature && !this.signature) {
          if (!this.allow_text_name && this.signature_text) {
            let canvasValue = document.getElementById('disclaimer-consent-canvas').getContext('2d') // Hidden canvas
            this.signature = canvasValue.canvas.toDataURL()
          } else {
            return false
          }
        }
        if (this.signature) {
          this.model['signature'] = this.signature
        }
        if (this.signature_text) {
          this.model['signature_text'] = this.signature_text
        }
        return this.$validator.validateAll()
      }
    },
    computed: {
      consent_text () {
        if (this.$store.state.lang.value === 'ES' && this.$store.state.site.patient_registration_consent_es) {
          this.text = this.$store.state.site.patient_registration_consent_es
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.$store.state.site.patient_registration_consent_zh) {
            this.text = this.$store.state.site.patient_registration_consent_zh
          } else {
            if (this.$store.state.lang.value === 'EN' && this.$store.state.site.patient_registration_consent) {
              this.text = this.$store.state.site.patient_registration_consent
            }
          }
        }
        let linksArray = this.text.match(/<a href="(.*?)">/g)
        if (linksArray) {
          for (let i = 0; i < linksArray.length; i++) {
              // if doesn't have target already put it
            if (!linksArray[i].includes('target="_blank')) {
              // controll if link has protocol if yes just add target
              if (linksArray[i].includes('http') || linksArray[i].includes('https') || linksArray[i].includes('href="//')) {
                let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('>')) + ' target="_blank"' + linksArray[i].slice(linksArray[i].indexOf('>'))
                this.text = this.text.replace(linksArray[i], toReturn)
                // if it doesn't have protocol add // so it wont redirect to localhost/www.userlink.com
              } else {
                let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('href="') + 6) + '//' + linksArray[i].slice(9)
                this.text = this.text.replace(linksArray[i], toReturn)
              }
            }
          }
        }
        return this.text
      },
      ...mapFields(['agreedConsent'])
    },
    watch: {
      '$store.state.configs.SCROLLBAR_DISCLAIMER_CONSENT': {
        handler: function (value) {
          this.allow_scrollbar = value
        }
      },
      '$store.state.configs.ALLOW_CHECKBOX_CONSENT': {
        handler: function (value) {
          this.allow_checkbox_consent = value
        }
      },
      '$store.state.configs.CONSENT_NAME_TEXT_REQUIREMENT': {
        handler: function (value) {
          this.allow_text_name = value
        },
        deep: true
      },
      '$store.state.configs.CONSENT_NAME_TEXT': {
        handler: function (value) {
          if (this.$store.state.configs.CONSENT_NAME_TEXT) {
            this.fields_en.if_you_can_not_sign = this.$store.state.configs.CONSENT_NAME_TEXT
          }
        }
      },
      '$store.state.configs.ALLOW_SIGNATURE_CONSENT': {
        handler: function (value) {
          this.allow_signature = value
        },
        deep: true
      },
      'signature_text': {
        handler: function (value) {
          if (this.allow_text_name) {
            if (this.signature_text) {
              this.validationObjectConsent.signatureConsentTextValidation = true
            } else {
              this.validationObjectConsent.signatureConsentTextValidation = false
            }
          } else {
            this.validationObjectConsent.signatureConsentTextValidation = true
            if (this.signature_text) {
              this.validationObjectConsent.signatureConsentValidation = true
            } else {
              this.validationObjectConsent.signatureConsentValidation = false
            }
            let canvasValue = document.getElementById('disclaimer-consent-canvas').getContext('2d') // Hidden canvas
            canvasValue.canvas.width = 450
            canvasValue.font = '72px "Allison"'
            canvasValue.fillText(this.signature_text, 30, 90)
          }
        }
      },
      'model.agreedConsent': {
        handler: function (value) {
          if (this.allow_checkbox_consent) {
            if (this.model.agreedConsent) {
              this.validationObjectConsent.agreedConsentValidation = true
            } else {
              this.validationObjectConsent.agreedConsentValidation = false
            }
          }
        }
      },
      'validationObjectConsent': {
        handler: function (before, after) {
          if (Object.values(this.validationObjectConsent).every(field => field === true)) {
            this.validatedConsentClass = 'validated-section-class'
          } else {
            this.validatedConsentClass = 'invalid-section-class'
          }
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  span{
    position: relative;
    padding-left: 25px;
    font-size: 1.25em;
    font-weight: 400;
    line-height: 1.4em;
  }
  .remove-padding{
    padding-left: 0px !important;
  }
  .p-2{
    padding:20px;
  }
  /*
  span:before{
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    margin: 10px 10px 10px 0px;
    left: 0;
    background-color:red;
    border: 1px solid black;
  }
  */
  .box {
    margin-top: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/ConsentStep.vue